import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Trans, withTranslation } from "react-i18next";
import TextField from "@material-ui/core/TextField";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import { withStyles, withTheme } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import IconButton from "@material-ui/core/IconButton";
import ClearIcon from "@material-ui/icons/Clear";
import CancelIcon from "@material-ui/icons/Cancel";
import Divider from "@material-ui/core/Divider";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Snackbar from "@material-ui/core/Snackbar";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import {
  anonAuthServiceClient,
  authServiceClient,
  taxServiceClient,
} from "../../AxiosClient";
import AddIcon from "@material-ui/icons/Add";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import InputAdornment from "@material-ui/core/InputAdornment";
import FormLabel from "@material-ui/core/FormLabel";
import Input from "@material-ui/core/Input";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import TaxonomyTree from "../../components/taxonomy/TaxonomyTree";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import FormGroup from "@material-ui/core/FormGroup";
import EditIcon from "@material-ui/icons/Edit";
import psl from "psl";
import TreeView from "@material-ui/lab/TreeView";
import LicenceInput from "../../components/licence/LicenceInput";
import TreeItem from "@material-ui/lab/TreeItem";
import KpsTextField from "../../components/KpsTextField";

const styles = (theme) => ({
  cancelButton: {
    margin: "0 auto 0 0",
  },
  infoContainer: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
  },
  textField: {
    marginBottom: theme.spacing(1),
    marginLeft: theme.spacing(1),
    "& input": theme.spacing(1),
  },
  paper: {
    overflow: "visible",
  },
  labelRoot: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0.5, 0),
  },
  labelIcon: {
    marginRight: theme.spacing(1),
  },
  labelText: {
    fontWeight: "inherit",
    flexGrow: 1,
    marginBottom: theme.spacing(1),
  },
  activeButtonCtr: {
    marginLeft: "auto",
    display: "flex",
  },
});
const taxonomySVG =
  "M10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z";
const topicSVG =
  "M12,3C7.58,3 4,4.79 4,7C4,9.21 7.58,11 12,11C16.42,11 20,9.21 20,7C20,4.79 16.42,3 12,3M4,9V12C4,14.21 7.58,16 12,16C16.42,16 20,14.21 20,12V9C20,11.21 16.42,13 12,13C7.58,13 4,11.21 4,9M4,14V17C4,19.21 7.58,21 12,21C16.42,21 20,19.21 20,17V14C20,16.21 16.42,18 12,18C7.58,18 4,16.21 4,14Z";

const OPERATOR_USER_TYPE = "named";

export class CreateOrganizationDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      name: "",
      id: "",
      idExists: false,
      licenceKey: "",
      validLicenceKey: false,
      systemadmin: "",
      firstName: "",
      surname: "",
      email: "",
      passwordReminder: "",
      adminpassword: "",
      showpassword: false,
      everyoneteam: "",
      authenticationType: "database",
      taxonomyTree: {
        id: "0",
        name: "All Knowledge",
        type: "taxonomy",
        object: { taxonomyName: "All Knowledge" },
        children: [],
      },
      topics: [],
      activeStep: 0,
      successSnackOpen: false,
      taxonomyToAdd: "",
      topicToAdd: "",
      activeNode: {
        id: "0",
        name: "All Knowledge",
        type: "taxonomy",
        object: { taxonomyName: "All Knowledge" },
        children: [],
      },
      treeId: 0,
      topicColourTheme: `${this.props.theme.palette.primary.dark}`,
      teamColourTheme: `${this.props.theme.palette.secondary.dark}`,
      taxonomyColourTheme: `${this.props.theme.palette.primary.light}`,
      expanded: ["0"],
      showTaxonomyInput: false,
      showTopicInput: false,
      editNodeLabel: false,
    };
    this.addTaxonomy = this.addTaxonomy.bind(this);
    this.addTopic = this.addTopic.bind(this);
  }

  componentDidMount = () => {};

  render() {
    const { classes, t } = this.props;
    return (
      <div style={{ height: "100%" }}>
        <Dialog
          fullWidth={true}
          open={this.props.fromMenu ? this.state.open : this.props.open}
          onClose={this.props.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          classes={{ paper: classes.paper }}
        >
          <DialogTitle>
            <Trans i18nKey="create_organization_header" />
          </DialogTitle>
          <DialogContent>
            <Stepper activeStep={this.state.activeStep} alternativeLabel>
              <Step>
                <StepLabel>
                  <Trans i18nKey="organization_stepper_basic_info" />
                </StepLabel>
              </Step>
              <Step disabled={!this.state.validLicenceKey}>
                <StepLabel>
                  <Trans i18nKey="organization_stepper_admin_user" />
                </StepLabel>
              </Step>
              <Step disabled={!this.state.validLicenceKey}>
                <StepLabel>
                  <Trans i18nKey="organization_stepper_authentication" />
                </StepLabel>
              </Step>
              <Step disabled={!this.state.validLicenceKey}>
                <StepLabel>
                  <Trans i18nKey="organization_stepper_categories" />
                </StepLabel>
              </Step>
            </Stepper>
            {this.state.activeStep === 0 && (
              <>
                <Typography style={{ marginBottom: 10 }}>
                  <Trans i18nKey="organization_info_header" />
                </Typography>
                <div className={classes.infoContainer}>
                  <FormGroup>
                    <KpsTextField
                      label={t("organization_name_label")}
                      value={this.state.name}
                      className={classes.textField}
                      onChange={this.handleChange("name")}
                      fullWidth={false}
                      size="small"
                    />
                    <KpsTextField
                      label={t("organization_id_label")}
                      value={this.state.id}
                      className={classes.textField}
                      onChange={this.handleChange("id")}
                      fullWidth={false}
                      size="small"
                      error={this.state.idExists}
                      helperText={
                        this.state.idExists
                          ? t("organization_id_exists")
                          : `${t("organization_id_helper_text")} ${
                              this.state.id
                            }.${psl.parse(window.location.hostname).domain}`
                      }
                    />
                    <LicenceInput
                      className={classes.textField}
                      licenceKey={this.state.licenceKey}
                      setKey={(licenceKey) => this.setState({ licenceKey })}
                      setLicenceValid={(valid) =>
                        this.setState({ validLicenceKey: valid })
                      }
                    />
                  </FormGroup>
                </div>
              </>
            )}
            {this.state.activeStep === 1 && (
              <>
                <Typography style={{ marginBottom: 10 }}>
                  <Trans i18nKey="organization_sytem_admin_info_header" />
                </Typography>
                <div style={{ display: "grid" }} className={classes.groupDiv}>
                  <FormLabel component="legend">
                    <Trans i18nKey="user_admin_password_settings" />
                  </FormLabel>
                  {/* <div style={{ display: 'flex' }}> */}
                  <FormControl className={classes.formControl}>
                    <KpsTextField
                      label={t("organization_systemadmin_label")}
                      value={this.state.systemadmin}
                      onChange={this.handleChange("systemadmin")}
                    />
                  </FormControl>
                  <FormControl className={classes.formControl}>
                    <KpsTextField
                      id="firstName"
                      label={t("personal_details_first_name_label")}
                      onChange={this.handleChange("firstName")}
                      value={this.state.firstName}
                    />
                  </FormControl>
                  <FormControl className={classes.formControl}>
                    <KpsTextField
                      label={t("personal_details_last_name_label")}
                      onChange={this.handleChange("surname")}
                      value={this.state.surname}
                    />
                  </FormControl>
                  <FormControl className={classes.formControl}>
                    <KpsTextField
                      label={t("personal_details_email_label")}
                      type="email"
                      onChange={this.handleChange("email")}
                      value={this.state.email}
                    />
                  </FormControl>
                  <FormControl className={classes.formControl}>
                    <InputLabel htmlFor="standard-adornment-password">
                      {t("label_password")}
                    </InputLabel>
                    <Input
                      id="standard-adornment-password"
                      type={this.state.showPassword ? "text" : "password"}
                      value={this.state.adminpassword}
                      onChange={(e) => {
                        this.setState({ adminpassword: e.target.value });
                      }}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label={t("toggle_password_visibility")}
                            onClick={this.handleClickShowPassword}
                            onMouseDown={this.handleMouseDownPassword}
                          >
                            {this.state.showPassword ? (
                              <Visibility />
                            ) : (
                              <VisibilityOff />
                            )}
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                  </FormControl>
                  <KpsTextField
                    label={t("preferences_reminder_phrase_label")}
                    onChange={this.handleChange("passwordReminder")}
                    value={this.state.passwordReminder}
                  />

                  {/* </div> */}
                </div>
              </>
            )}
            {this.state.activeStep === 2 && (
              <>
                <Typography style={{ marginBottom: 10 }}>
                  <Trans i18nKey="organization_auth_settings_header" />
                </Typography>
                <div>
                  <Typography style={{ marginTop: 5, marginBottom: 20 }}>
                    <Trans i18nKey="organization_authentication_header" />
                  </Typography>
                  <div className={classes.infoContainer}>
                    <Typography style={{ marginTop: 10, marginBottom: -5 }}>
                      <Trans i18nKey="organization_authentication_type_info" />
                    </Typography>
                    <FormControl className={classes.formControl}>
                      <InputLabel htmlFor="authenticationType">
                        <Trans i18nKey="organization_authentication_type" />
                      </InputLabel>
                      <Select
                        value={this.state.authenticationType}
                        onChange={this.handleAuthenticationTypeChange}
                      >
                        <MenuItem key="databaseAuthentication" value="database">
                          <Trans i18nKey="organization_database_authentication" />
                        </MenuItem>
                        <MenuItem key="ldapAuthentication" value="ldap">
                          <Trans i18nKey="organization_ldap_authentication" />
                        </MenuItem>
                        <MenuItem
                          key="ldapDatabaseAuthentication"
                          value="ldapdatabase"
                        >
                          <Trans i18nKey="organization_ldapdatabase_authentication" />
                        </MenuItem>
                      </Select>
                    </FormControl>
                    <Paper />
                  </div>
                </div>
              </>
            )}
            {this.state.activeStep === 3 && (
              <>
                <Typography style={{ marginBottom: 10 }}>
                  <Trans i18nKey="organization_categories_header" />
                </Typography>
                <div className={classes.infoContainer}>
                  <Paper>
                    <TreeView
                      className={classes.root}
                      defaultExpanded={this.state.expanded}
                      defaultCollapseIcon={<ChevronRightIcon />}
                      defaultExpandIcon={<ExpandMoreIcon />}
                      defaultEndIcon={<div style={{ width: 24 }} />}
                      children={this.renderNode(this.state.taxonomyTree)}
                      disableSelection={true}
                    />
                  </Paper>
                </div>
              </>
            )}
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.handleClose}
              color="primary"
              className={classes.cancelButton}
            >
              <Trans i18nKey="global_cancel" />
            </Button>
            {this.state.activeStep > 0 &&
              this.state.validLicenceKey && (
                <Button onClick={this.handleBack} color="primary" autoFocus>
                  <Trans i18nKey="">
                    <Trans i18nKey="global_back" />
                  </Trans>
                </Button>
              )}
            {this.state.validLicenceKey && (
              <Button
                disabled={this.validSystemAdmin()}
                onClick={this.handleNext}
                color="primary"
                autoFocus
              >
                {this.state.activeStep === 3 ? (
                  <Trans i18nKey="global_create" />
                ) : (
                  <Trans i18nKey="global_next" />
                )}
              </Button>
            )}
          </DialogActions>
        </Dialog>
        <Snackbar
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          open={this.state.successSnackOpen}
          autoHideDuration={3000}
          onClose={this.handleSnackClose}
          message={t("organization_added_successfully")}
        />
      </div>
    );
  }

  onClickNode = (e, node) => {
    if (node !== this.state.activeNode) {
      this.setState({ activeNode: node });
      this.onNodeSelected(node);
    }
    e.stopPropagation();
  };
  onNodeSelected = (node) => {};
  renderNode = (node, idx) => {
    const { classes, t } = this.props;

    let childNodes = node.children.filter(
      (ele) => ele.type === "taxonomy" || ele.type === "topic"
    );
    return (
      <TreeItem
        nodeId={node.id}
        key={idx}
        // onClick={(e) => e.stopPropagation()}
        label={
          <div
            className={classes.labelRoot}
            onClick={(e) => this.onClickNode(e, node)}
          >
            <div className={classes.labelIcon}>
              <svg height="24px" width="24px">
                <path
                  fill={
                    node.type === "taxonomy"
                      ? this.state.taxonomyColourTheme
                      : this.state.topicColourTheme
                  }
                  d={node.type === "taxonomy" ? taxonomySVG : topicSVG}
                />
              </svg>
            </div>
            {node === this.state.activeNode ? (
              <>
                <KpsTextField
                  className={classes.textField}
                  defaultValue={node.name}
                  onChange={(e) => {
                    node.name = e.target.value;
                    node.object[node.type + "Name"] = e.target.value;
                  }}
                  size="small"
                />
              </>
            ) : (
              <Typography className={classes.labelText}>{node.name}</Typography>
            )}

            {node === this.state.activeNode && (
              <div className={classes.activeButtonCtr}>
                {this.state.showTopicInput !== true && (
                  <Button
                    size="small"
                    onClick={() => {
                      this.setState({ showTaxonomyInput: true });
                    }}
                    disabled={this.state.activeNode.type !== "taxonomy"}
                    startIcon={<AddIcon />}
                  >
                    {t("global_taxonomy")}
                  </Button>
                )}
                {this.state.showTaxonomyInput === true && (
                  <>
                    <KpsTextField
                      disabled={this.state.activeNode.type !== "taxonomy"}
                      className={classes.textField}
                      value={this.state.taxonomyToAdd}
                      onChange={(e) => {
                        this.setState({ taxonomyToAdd: e.target.value });
                      }}
                      size="small"
                      InputProps={{
                        endAdornment: (
                          <>
                            <IconButton
                              size="small"
                              disabled={this.state.taxonomyToAdd.length === 0}
                              onClick={this.addTaxonomy()}
                            >
                              <CheckCircleIcon />
                            </IconButton>
                            <IconButton
                              size="small"
                              onClick={() => {
                                this.setState({
                                  taxonomyToAdd: "",
                                  showTaxonomyInput: false,
                                });
                              }}
                            >
                              <CancelIcon />
                            </IconButton>
                          </>
                        ),
                      }}
                    />
                  </>
                )}
                {this.state.showTaxonomyInput !== true && (
                  <Button
                    size="small"
                    onClick={() => {
                      this.setState({ showTopicInput: true });
                    }}
                    disabled={this.state.activeNode.type !== "taxonomy"}
                    startIcon={<AddIcon />}
                  >
                    {t("global_topic")}
                  </Button>
                )}
                {this.state.showTopicInput === true && (
                  <>
                    <KpsTextField
                      disabled={this.state.activeNode.type !== "taxonomy"}
                      className={classes.textField}
                      value={this.state.topicToAdd}
                      onChange={(e) => {
                        this.setState({ topicToAdd: e.target.value });
                      }}
                      size="small"
                      InputProps={{
                        endAdornment: (
                          <>
                            <IconButton
                              size="small"
                              disabled={this.state.topicToAdd.length === 0}
                              onClick={this.addTopic()}
                            >
                              <CheckCircleIcon />
                            </IconButton>
                            <IconButton
                              size="small"
                              onClick={() => {
                                this.setState({
                                  topicToAdd: "",
                                  showTopicInput: false,
                                });
                              }}
                            >
                              <CancelIcon />
                            </IconButton>
                          </>
                        ),
                      }}
                    />
                  </>
                )}
                {this.state.showTopicInput === false &&
                  this.state.showTaxonomyInput === false && (
                    <IconButton
                      size="small"
                      disabled={this.state.activeNode.id === "0"}
                      onClick={this.deleteNode()}
                    >
                      <ClearIcon />
                    </IconButton>
                  )}
              </div>
            )}
          </div>
        }
      >
        {childNodes.map((child, idx) => {
          return this.renderNode(child, idx);
        })}
      </TreeItem>
    );
  };

  validSystemAdmin = () => {
    let isValid = this.state.activeStep === 1;
    return isValid
      ? this.state.adminpassword.trim().length === 0 ||
          this.state.systemadmin.trim().length === 0
      : isValid;
  };

  handleClickShowPassword = () => {
    this.setState({ showPassword: !this.state.showPassword });
  };

  handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  handleSnackClose = () => {
    this.setState({ successSnackOpen: false });
  };

  removeTopic = (topic) => {
    this.setState({
      topics: this.state.topics.filter((ele) => ele.name !== topic.name),
    });
  };

  removeTaxonomy = (taxonomy) => {
    this.setState({
      taxonomies: this.state.taxonomies.filter(
        (ele) => ele.name !== taxonomy.name
      ),
    });
  };

  onUserSelected = (user) => {
    this.setState({ users: [...this.state.users, user] });
  };

  handleClose = () => {
    if (this.props.fromMenu) {
      this.setState({ open: false });
      this.props.onClose();
    } else {
      this.props.handleClose();
    }
  };

  handleBack = () => {
    this.setState({ activeStep: this.state.activeStep - 1 });
  };

  handleNext = () => {
    if (this.state.activeStep === 0) {
      taxServiceClient
        .get(`/organization/${this.state.id}/exists`)
        .then((res) => {
          if (res.status === 204) {
            // this org ID already exists
            this.setState({ idExists: true });
          }
        })
        .catch(() => {
          // swallow the 404
          this.setState({ idExists: false });
          this.setState({ activeStep: this.state.activeStep + 1 });
        });
      return;
    }
    if (this.state.activeStep < 3) {
      this.setState({ activeStep: this.state.activeStep + 1 });
    } else {
      let organizationDTO = {
        organizationName: this.state.name,
        taxonomyNodes: this.state.taxonomyTree,
        authenticationType: this.state.authenticationType,
        organizationId: this.state.id,
      };
      let userDTO = this.createUserDTO();
      let teamDTO = { teamName: "Everyone" };
      let key = this.state.licenceKey;
      this.state.validLicenceKey === true &&
        anonAuthServiceClient
          .post(`/licence/${this.state.id}/license`, { key })
          .then((res) => {
            taxServiceClient
              .post("/organization/", {
                organizationDTO: organizationDTO,
                userDTO: userDTO,
                teamDTO: teamDTO,
              })
              .then((res) => {
                this.setState({ open: false, successSnackOpen: true });
                this.handleClose();
              });
          });
    }
  };
  addTaxonomy = () => (event) => {
    let treeId = parseInt(this.state.treeId) + 1;
    let tax = {
      id: "" + treeId,
      name: this.state.taxonomyToAdd,
      type: "taxonomy",
      object: { taxonomyName: this.state.taxonomyToAdd },
      children: [],
    };
    let node = this.state.activeNode;
    this.state.expanded.push("" + treeId);
    node.children.push(tax);
    this.setState({
      treeId: treeId,
      taxonomyTree: this.updateTree(
        this.state.taxonomyTree,
        this.state.activeNode
      ),
      taxonomyToAdd: "",
      showTaxonomyInput: false,
      expanded: this.state.expanded,
    });
  };
  addTopic = () => (event) => {
    let treeId = parseInt(this.state.treeId) + 1;
    let topic = {
      id: "" + treeId,
      name: this.state.topicToAdd,
      type: "topic",
      object: { topicName: this.state.topicToAdd },
      children: [],
    };
    let node = this.state.activeNode;
    node.children.push(topic);
    this.state.expanded.push("" + treeId);
    this.setState({
      treeId: treeId,
      taxonomyTree: this.updateTree(
        this.state.taxonomyTree,
        this.state.activeNode
      ),
      topicToAdd: "",
      showTopicInput: false,
      expanded: this.state.expanded,
    });
  };
  deleteNode = () => (event) => {
    this.setState({
      taxonomyTree: this.deleteFromTree(
        this.state.taxonomyTree,
        this.state.activeNode
      ),
    });
  };
  deleteFromTree = (node, child) => {
    let updated = node;
    if (node.id !== child.id) {
      let children = node.children;
      node.children.forEach((nodeEl, idx) => {
        nodeEl.id === child.id
          ? children.splice(idx, 1)
          : (children[idx] = this.deleteFromTree(nodeEl, child));
      });
      updated.children = children;
    }
    return updated;
  };
  updateTree = (node, updatedNode) => {
    let updated = node;
    if (node.id === updatedNode.id) {
      updated.children = updatedNode.children;
    } else {
      let children = [];
      node.children.forEach((nodeEl) => {
        children.push(this.updateTree(nodeEl, updatedNode));
      });
      updated.children = children;
    }
    return updated;
  };

  handleChange = (name) => (event) => {
    if (name === "name") {
      let newKebabCased = event.target.value.replace(/\s+/g, "-").toLowerCase();
      let oldKebabCased = this.state.name.replace(/\s+/g, "-").toLowerCase();
      if (this.state.id === oldKebabCased) {
        this.setState({ id: newKebabCased });
      }
    }
    if (name === "id") {
      if (this.state.idExists) {
        this.setState({ idExists: false });
      }
      if (!event.target.value && this.state.name) {
        this.setState({
          id: this.state.name.replace(/\s+/g, "-").toLowerCase(),
        });
        return;
      }
      this.setState({
        id: event.target.value.replace(/\s+/g, "-").toLowerCase(),
      });
      return;
    }
    this.setState({ [name]: event.target.value });
  };
  handleAuthenticationTypeChange = (e) => {
    this.setState({
      authenticationType: e.target.value,
    });
  };

  createUserDTO = () => {
    let userDTO = {};
    userDTO.userLogin = this.state.systemadmin;
    userDTO.password = this.state.adminpassword;
    userDTO.firstName = this.state.firstName;
    userDTO.surname = this.state.surname;
    userDTO.userCanChangePassword = 1;
    userDTO.namedUser = 1;
    userDTO.email = this.state.email;
    userDTO.reminderPhrase = this.state.reminderPhrase;
    userDTO.userType = OPERATOR_USER_TYPE;
    userDTO.userPermits = {
      roles: {
        none: false,
        user: true,
        beExpert: true,
        moderator: true,
        reporter: true,
        systemManager: true,
        administrator: true,
        askExpert: true,
        hotTopicer: true,
        approver: true,
        requiredReading: true,
        reviewer: true,
        publisher: true,
        forumModerator: false,
      },
    };

    return userDTO;
  };
}

export default withTranslation()(
  withTheme(withStyles(styles)(CreateOrganizationDialog))
);
